import { render, staticRenderFns } from "./length.vue?vue&type=template&id=1316ef83&scoped=true&"
import script from "./length.vue?vue&type=script&lang=js&"
export * from "./length.vue?vue&type=script&lang=js&"
import style0 from "./length.vue?vue&type=style&index=0&id=1316ef83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1316ef83",
  null
  
)

export default component.exports